/**
 * getByPath.js
 *
 * @Author: jruif
 * @Date: 2017/7/17 下午5:27
 */

import {
  isString, isSymbol, isNumber, isObject,
} from './isType';

/**
 * 如果value不是一个string或symbol，则转化为string
 *
 * @param {any} value
 * @returns {string|symbol}
 */
export const toKey = value => {
  if (isString(value) || isSymbol(value)) {
    return value;
  }
  const result = `${value}`;
  return result === '0' && 1 / value === -Infinity ? '-0' : result;
};

const getByPath = (object, path) => {
  let index = 0;
  let len;
  let isBasics = false;
  if (isString(path)) {
    path = path.split(/[\s,.]+/g);
  } else if (isNumber(path)) {
    path = [path];
  }

  if (!Array.isArray(path)) {
    throw new Error('The types of path must be a string or a number or an array ');
  }
  len = path.length;
  while (object !== null && index < len) {
    const current = object[toKey(path[index++])];
    if (isObject(current) || Array.isArray(current)) {
      object = current;
    } else {
      isBasics = true;
      break;
    }
  }
  return {
    object,
    path,
    isBasics, // 是否是普通类型（不是引用类型）
  };
};

export default getByPath;
